module.exports = __webpack_public_path__ + "static/media/notapp2.ed6c2492.PNG";